/**
 * Theme version
 */
export const version = '4.0.0';

/**
 * Domain to use with the import/export script
 */
export const domain = 'https://live-lacers.pantheonsite.io';

/**
 * Path/page to append to the domain to use with the import/export script.
 */
export const path = '/user';

/**
 * Centralized offsets used by various components.
 */
export const offsets = {
  // offsets for each breakpoint
  mobile: 227,
  tablet: 181,
  desktop: 0,
  larger: 0,
  // other offsets for extended functionality
  sidebar: 35,
  padding: 20,
};

/**
 * Theme Breakpoints
 */
export const breakpoints = {
  mobile: {
    min: 0,
    max: 767,
  },
  tablet: {
    min: 768,
    max: 1024,
  },
  desktop: {
    min: 1025,
    max: 1199,
  },
  larger: {
    min: 1200,
    max: Infinity,
  }
};

/**
 * Default export of theme related info.
 */
export default version;
